import { CSSProperties } from 'react';
import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';
import { styled } from '@mui/material/styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import { scrollBar, ArrowsStyle } from '~/styles/useStyleGlobal';

const useStyles = () => ({
  carouselContainer: {
    width: '100%',
    borderRadius: '8px',

    '&:hover': {
      ...ArrowsStyle,
    },
  },
});

export const carouselContainer = {
  width: '100%',
  height: '100%',
  borderRadius: '8px',

  '&:hover': {
    ...ArrowsStyle,
  },
};

export const StyledSwiperSlide = styled(SwiperSlide)(() => ({
  width: '100%',
  height: '216px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: '20px',
  [theme.breakpoints.up('md')]: {
    webkitTapHightlightColor: 'transparent',
    webkitTouchCallout: 'none',
    webkitUserSelect: 'none',
    khtmlUserSelect: 'none',
    mozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
  },
}));

export const StyledSwiper = styled(Swiper, {
  shouldForwardProp: (prop) =>
    prop !== 'noImages' && prop !== 'isNavigationDots',
})<{ noImages: boolean; isNavigationDots: boolean }>(
  ({ noImages = true, isNavigationDots = false }) => ({
    width: '100%',
    borderRadius: '8px',

    '& .swiper-button-prev, .swiper-button-next': {
      display: 'none',
    },
    '&:hover': {
      ...ArrowsStyle,
    },
    '& .swiper-pagination': {
      display: !isNavigationDots ? 'none' : 'block',
    },
    '& .swiper-pagination-bullet': {
      background: COLORS.black.light2,
      opacity: '0.5',
    },
    '& .swiper-pagination-bullet-active': {
      boxSizing: 'border-box',
      background: COLORS.yellow.main,
      border: `1px solid ${COLORS.black.main}`,
    },
    '& .swiper-pagination-bullets.swiper-pagination-horizontal': {
      bottom: '0px',
    },
    '& div.swiper-wrapper': {
      overflow: noImages ? 'hidden' : 'auto hidden',
      ...scrollBar,
    },
  }),
);

export const imageKitStyle: CSSProperties = {
  width: '100%',
};

export const imageStyle: CSSProperties = {
  height: '100%',
  width: '100%',
  objectFit: 'contain',
  borderRadius: '8px',
  position: 'fixed',
};

export default useStyles;
